import { useEffect, useRef, useState } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectActiveChannel } from '@/store/slices/user/selectors';
import GetGlobalTemplateTypes from '@/connection/projects/get-global-template-types';
import isGlobalTemplatesActiveChannel from '@ui/auth-wrapper/helpers/is-global-templates-active-channel';

type Params = {
  bypass?: boolean;
};

const useFetchGlobalTemplateTypes = (params?: Params) => {
  const bypass = params?.bypass;
  const activeChannel = useAppSelector(selectActiveChannel);

  const [fetching, setFetching] = useState(false);
  const [globalTemplateTypes, setGlobalTemplateTypes] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [refetch, setRefetch] = useState(0);

  const fetchingGlobalTypes = useRef(false);

  useEffect(() => {
    const fetchingOrHasTypes = globalTemplateTypes.length || fetchingGlobalTypes.current;
    const isNotAuthorized = !isGlobalTemplatesActiveChannel(activeChannel);

    if (bypass || fetchingOrHasTypes || isNotAuthorized) {
      return;
    }

    setFetching(true);
    fetchingGlobalTypes.current = true;

    (async () => {
      try {
        setError(null);
        const types = await GetGlobalTemplateTypes();
        setGlobalTemplateTypes(types || []);
      } catch (e) {
        console.error(e);
        setError('ERROR: There was an error fetching this list. Try closing and re-opening this dropdown.');
      } finally {
        fetchingGlobalTypes.current = false;
        setFetching(false);
      }
    })();
  }, [activeChannel, bypass, globalTemplateTypes.length, refetch]);

  return { fetching, globalTemplateTypes, error, setRefetch };
};

export default useFetchGlobalTemplateTypes;
